import { get, post, put, patch } from "../Config"

export function SearchCorporateGovernance({ params = {}, lang }) {
  return get({ url: `/v1/admin/corporate-governance`, params, lang })
}
export function GetCorporateGovernanceById({ id, lang }) {
  return get({ url: `/v1/admin/corporate-governance/${id}`, lang })
}
export function CreateCorporateGovernance({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/corporate-governance`, params, data, lang })
}
export function UpdateCorporateGovernance({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/corporate-governance/${id}`, params, data, lang })
}
export function PatchCorporateGovernance({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/corporate-governance/${id}`, params, data, lang })
}
export function DeleteCorporateGovernance({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/corporate-governance/mutiDelete`, params, data, lang })
}
